import React from 'react';
import PropTypes from 'prop-types';
import {List, Subheader, Divider, Paper} from 'material-ui';
import Error from "../../common/Error/Error";
import ReportItem from './ReportItem';
import style from '../../../styles/styles';

const ReportList = (props) => {
    const { reports, title, user, app } = props;

    let content;

    if (reports.length === 0) {
        content =
            <Error
                title="No data"
                subtitle="Add some reports"
            />
    }  else {
        content = reports.map(function(report, index) {
            return <div key={report.id}>
                <ReportItem
                    app={app}
                    user={user}
                    report={report}
                />
                {index !== (reports.length - 1) &&  <Divider inset={true}/>}
            </div>
        })
    }

    return (
        <Paper>
            <List>
                <Subheader style={style.subHeader}>{title}</Subheader>
                {content}
            </List>
        </Paper>
    );
};

ReportList.propTypes = {
    reports: PropTypes.arrayOf(PropTypes.object).isRequired,
    user: PropTypes.object.isRequired,
    app: PropTypes.object.isRequired,
    title: PropTypes.string
};

export default ReportList;



// WEBPACK FOOTER //
// src/components/report/Report/ReportList.js